import { Flex } from "@chakra-ui/react"
import axios from "axios"
import LoadingSpinner from "components/PaymentStudent/LoadingSpinner"
import PaymentError from "components/PaymentStudent/PaymentError"
import PaymentSuccess from "components/PaymentStudent/PaymentSuccess"
import { api } from "config"
import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

const PaymentConfirmation: React.FC = () => {
  const params = new URLSearchParams(useLocation().search)

  const resultIndicator = params.get("resultIndicator")
  const paypalSuccess = params.get("paypal")

  const [paymentStatus, setPaymentStatus] = useState("loading")

  useEffect(() => {
    // NEW PAYPAL BUTTON FLOW
    if (paypalSuccess === "success") {
      setPaymentStatus("success")
      return
    }

    if (paypalSuccess === "failed") {
      setPaymentStatus("error")
      return
    }

    // COMBANK FLOW
    if (!resultIndicator) {
      setPaymentStatus("error")
      return
    }

    setPaymentStatus("loading")

    axios
      .post(
        `${api}/payments/set-paid-status-combank`,
        {
          resultIndicator,
        },
        {
          withCredentials: true,
        },
      )
      .then(() => {
        setPaymentStatus("success")
      })
      .catch((err) => {
        console.error(err)
        setPaymentStatus("error")
      })
  }, [resultIndicator, paypalSuccess])

  return (
    <Flex h={"80vh"} alignItems="center" w={"100%"} justifyContent="center">
      {paymentStatus === "loading" && <LoadingSpinner />}
      {paymentStatus === "success" && <PaymentSuccess />}
      {paymentStatus === "error" && <PaymentError />}
    </Flex>
  )
}

export default PaymentConfirmation
